import React, { useMemo } from 'react';
import './snowfall.scss';

const isSnowActive = (d: Date = new Date()) => {
  const month = d.getMonth() + 1;
  const day = d.getDate();
  return (month === 12 && day >= 20) || (month === 1 && day <= 8);
};

type Flake = {
  id: number;
  left: number;
  size: number;
  duration: number;
  delay: number;
  opacity: number;
};

const Snowfall: React.FC = () => {
  const active = isSnowActive();

  const flakes = useMemo(() => {
    const arr: Flake[] = [];
    for (let i = 0; i < 40; i++) {
      arr.push({
        id: i,
        left: Math.random() * 100,
        size: 8 + Math.random() * 20,
        // slow down fall: increase base duration
        duration: 12 + Math.random() * 14,
        delay: Math.random() * 8,
        opacity: 0.4 + Math.random() * 0.6,
      });
    }
    return arr;
  }, []);
  if (!active) return null;

  return (
    <div className="snowfall" aria-hidden>
      {flakes.map((f) => {
        // slightly slower sway: increase duration range
        const swayDur = 3 + Math.random() * 4; // seconds
        const swayRange = 10 + Math.random() * 40; // px
        return (
          <span
            key={f.id}
            className="snowflake-wrapper"
            style={{
              left: `${f.left}%`,
              // CSS variable used by sway keyframes
              ['--sway' as any]: `${swayRange}px`,
              animation: `sway ${swayDur}s ease-in-out ${f.delay}s infinite`,
            }}
          >
            <span
              className="snowflake"
              style={{
                fontSize: `${f.size}px`,
                animation: `fall ${f.duration}s linear ${f.delay}s infinite`,
                opacity: f.opacity,
              }}
            >
              ❄
            </span>
          </span>
        );
      })}
    </div>
  );
};

export default Snowfall;
